import { useSelector } from 'react-redux';
import { IoIosMore } from "react-icons/io";
import { useState } from 'react'
import { Menu, MenuItem , MenuButton, MenuItems } from '@headlessui/react';
import Loader from '../../components/Loader';
import ConfirmDeactivate from '../../Modals/ConfirmDeactivate';

const UserManagementTable = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const user = useSelector((state) => state.user);

  const handleDeactivate = async (item) => {
    setSelectedUser(item); 
    setIsDeleteOpen(true);
  }
  const users = user?.user?.data
  
  return (
    <div className="flow-root bg-white">
        <div className="overflow-x-auto rounded-tr-lg rounded-tl-lg">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full divide-y divide-gray-300 table-auto border p-4">
              <thead className="bg-primaryGray">
                <tr>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">
                    S/N
                  </th>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold capitalize text-gray-900">
                    Admin name
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-gray-900">
                    Role
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-gray-900">
                    Status
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-gray-900">
                    Last login (Date & Time)
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-gray-900">
                    Action
                  </th>
                </tr> 
              </thead>
              <tbody>
                {user?.loading ? (
                  <Loader /> 
                ) :
                users && users.length > 0 ? (
                  <>
                    {users.map((user, index) =>(
                      <tr key={index} className="border-b border-b-primaryGray">
                      <td className="whitespace-nowrap px-3 text-xs md:text-sm text-black capitalize">{`${index + 1}`}</td>
                        <td className="px-3 py-4 text-xs md:text-sm text-black capitalize">
                          <span className="flex items-center">
                            {user?.profileImage && (
                              <img src={user?.profileImage} alt="card" className="rounded-full h-[20px] w-[20px] md:h-[40px] md:w-[40px]" />
                            )}
                            <span className="pl-2 font-semibold">{user?.userName}</span>
                          </span>
                        </td>
                      <td className="whitespace-nowrap px-3 ml-3 text-xs md:text-sm text-black capitalize">
                        {user?.roleName }
                      </td>
                      <td>
                         <span className={`text-xs md:text-sm text-white capitalize inline-block w-[120px] text-center px-3 py-2 rounded-md bg-[#008000]`}>Active</span>
                        </td>
                      <td className="whitespace-nowrap px-3 text-center text-xs md:text-sm text-black capitalize">{user?.lastLoginDateTime}
                      </td>
                      <td className="whitespace-nowrap px-3 text-xs md:text-sm text-gray-500">
                        <Menu as="div" className="relative inline-block text-left">
                          <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-0 px-3 py-2 text-sm font-semibold text-[#B3B3B3] ring-0 outline-none">
                              <IoIosMore />
                            </MenuButton>
                          </div>
                          <MenuItems
                            transition
                            className="absolute right-0 z-50 mt-2 w-fit origin-top-right rounded-md bg-[#DADADA] shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                          >
                            <div className="py-1">
                              <MenuItem>
                                <button
                                  className="block w-full px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-[#0A0A0A] hover:text-medium data-[focus]:outline-none text-left hover:bg-none" onClick={() => handleDeactivate(user)}>
                                    Deactivate User Account
                                </button>
                            </MenuItem>
                            </div>
                          </MenuItems>
                        </Menu>
                      </td>
                    </tr>
                    ))}
                  </>
                ): (
                  <p className='flex items-center text-primaryRed py-4 justify-center text-sm'>No Users Currently</p>
                )}
              </tbody>
            </table>
            <ConfirmDeactivate
              item={selectedUser}
              isOpen={isDeleteOpen}
              onClose={() => setIsDeleteOpen(false)}
            />
          </div>
        </div>
    </div>
  );
}

export default UserManagementTable;
